export default __webpack_public_path__ + "static/media/cardimage2.653db0a7.png";